import { FileText } from 'lucide-react'

const Rules = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative text-white min-h-[300px] flex items-center"
        style={{
          backgroundImage: 'url(/images/club/image-eceb046f.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-primary-900/80 via-primary-700/75 to-secondary-900/80"></div>
        <div className="container-custom relative z-10 py-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block mb-6">
              <FileText className="w-16 h-16 mx-auto" />
            </div>
            <h1 className="mb-6 animate-fade-in text-4xl md:text-5xl lg:text-6xl font-bold">
              Rules &amp; Regulations
            </h1>
            <p className="text-xl md:text-2xl leading-relaxed opacity-95 max-w-3xl mx-auto">
              Important guidelines for all members to ensure a safe and enjoyable experience for everyone
            </p>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-10 bg-white">
        <div className="container-custom max-w-5xl">
          <div className="bg-primary-50 border-l-4 border-primary-600 p-6 rounded-lg mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">For All Members</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The following Rules and Regulations are for the protection and benefit of all Members. Each Member is responsible for understanding the rules and ensuring their children and guests understand them. Questions regarding rules interpretation and their enforcement should be forwarded to the Board of Directors at <a href="mailto:admin@lockridgeforestswimtennis.com" className="text-primary-600 hover:underline">admin@lockridgeforestswimtennis.com</a>.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Your suggestions and recommendations are encouraged and welcomed. Please avoid confrontations with responsible officers and employees in their enforcement of these rules.
            </p>
          </div>

          {/* Liability Waiver */}
          <div className="bg-red-50 border-l-4 border-red-600 p-6 rounded-lg mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Club Use Liability Waiver</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The Club assumes no responsibility, and Members or their guests shall have no claims against the Club, for any accident or injury to any person or their property. All persons using the Club's facilities do so at their own risk. Only Members who have paid their dues in full and remain in good standing and authorized guests shall be permitted to use the Club's facilities. The Club Use Liability Waiver is documented in the Club Bylaws paragraph 6.10 is in effect for all persons using the club facilities.
            </p>
            <p className="text-red-700 font-bold text-lg">
              Important – USE THE FACILITY / POOL AT YOUR OWN RISK.
            </p>
          </div>

          {/* Table of Contents */}
          <div className="bg-gray-50 border border-gray-300 rounded-lg p-6 mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Table of Contents</h2>
            <ul className="grid md:grid-cols-2 gap-3 text-primary-600">
              <li><a href="#common-rules" className="hover:underline">• Common Club Rules and Regulations</a></li>
              <li><a href="#pool-hours" className="hover:underline">• Pool Hours</a></li>
              <li><a href="#pool-guests" className="hover:underline">• Pool Guest(s)</a></li>
              <li><a href="#parties" className="hover:underline">• Get Togethers and Parties</a></li>
              <li><a href="#facility-guidelines" className="hover:underline">• Tennis Pavilion / Taj Reservation Guidelines</a></li>
            </ul>
          </div>

          {/* Common Club Rules */}
          <section id="common-rules" className="mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-2 border-primary-600 pb-3">
              Common Club Rules and Regulations
            </h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded mb-6">
              <p className="text-gray-800 font-semibold">
                NOTE: Residents of Lockridge Forest who are not members of the Swim &amp; Tennis Club and any other non-members are not permitted, other than member guests, to use any part of the facility or attend any function held at the facility without permission by a majority vote of Board members.
              </p>
            </div>
            <p className="text-gray-700 mb-6">
              A member is anyone who resides in a household for which the appropriate dues have been paid. A guest is anyone visiting a paid household, or an individual who lives outside of Lockridge Forest and has been invited by a member to join them using the facility. Persons living in Lockridge Forest who are not part of a dues paying household cannot be guests without prior approval of the Board.
            </p>
            <ol className="space-y-4 list-decimal list-inside text-gray-700">
              <li>Club operating hours are Sunrise to Sunset except for scheduled events, functions where a facility has been reserved by a member and approved by the Board, and Swimming and Tennis which have separate posted hours. All other members must leave the facility at sunset. No loitering on Club property after closing hours.</li>
              <li>Relatives and friends are permitted to use the facilities at any time while accompanied by a member.</li>
              <li>For the purpose of Club Rules an adult is anyone 18 years old or older.</li>
              <li>Profane or abusive language, gross behavior, or unsafe conduct which in the opinion of the Pool Manager, any Board member, or lifeguard on duty is unacceptable or unsafe may result in the temporary or permanent suspension of that Member or child.</li>
              <li>Consumption of alcoholic beverages on Club property is a matter of personal preference. A person showing signs of intoxication may be asked to leave the Club facilities and is subject to suspension and/or expulsion. No person younger than 21 years old shall be allowed to bring or consume any alcoholic beverage on any part of the club's premises.</li>
              <li>Any person(s) using illegal drugs on Club property may be reported to the proper authorities and subject to immediate suspension and/or expulsion from the CLUB.</li>
              <li>All trash, including cigarettes, is to be discarded into a proper disposal container. Large items such as pizza boxes, cake boxes, etc. should be discarded directly in the dumpster to minimize bees and hornets around trash receptacles. Trash receptacles are to be emptied when full and receptacles relined for next use. Take trash to the dumpster for discard.</li>
              <li>Maximum vehicle speed on the Club property is 10MPH.</li>
              <li>Licensed vehicles, including motorcycles and minibikes, operated by licensed drivers including unlicensed vehicles such as golf carts can park in authorized club parking area. Do not park on the road, parking lot shoulders, or grass at any time.</li>
              <li>In general, vehicles are not permitted to use the Taj as a parking area, with the exception of golf carts, vehicles transporting a handicapped person(s), and individual vehicles needed to drop off or pickup supplies for an event.</li>
              <li>Bicycles, when parked, must be in a bike rack if provided. If no bike rack is provided, the designated bike parking area is adjacent to the main pool entry gate.</li>
              <li>No person shall take any article belonging to the Club away from the Club premises without prior approval from a board member.</li>
              <li>Unleashed dogs are allowed on Club property only with attentive owners. If members present are uncomfortable with the dog(s) being off leash, a leash must be used. All persons with dogs on club property are responsible for cleaning up after them. Please take extra caution when large groups or children are present. Many small children are frightened of dogs of all sizes. No dogs allowed on the pool deck area.</li>
              <li>A Member who damages or defaces Club property will be responsible for the repair or replacement of the same. In the case of children, parents will be responsible for all costs. In the case of guests, the Member is ultimately responsible for all costs.</li>
              <li>Climbing over the pool enclosure fences is forbidden and may result in suspension of pool privileges.</li>
              <li>Security of the CLUB Property is the responsibility of ALL Members. Members must abide by the rules regarding locking the tennis courts after use, locking the main pool gate (last to leave pool), and locking the property entry gate at the top of the hill (last vehicle leaving property regardless of time of day).</li>
            </ol>
          </section>

          {/* Pool Hours */}
          <section id="pool-hours" className="mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-2 border-primary-600 pb-3">
              Pool Hours
            </h2>
            <ol className="space-y-4 list-decimal list-inside text-gray-700">
              <li>Effective with the 2026 season, normal pool hours for all Members shall be from 10:00 AM until dusk or 9:00 PM, whichever occurs earliest, unless otherwise posted by the Board of Directors.</li>
              <li>Effective with the 2026 season, guarded pool hours for all Members shall be 4:00 - 8:00 PM weekdays and 12 noon - 8:00 PM weekends. No lifeguards will be on duty at other times unless a special event is planned, and lifeguards are contracted for the event.</li>
              <li>All non-lifeguarded hours are "Swim at Your Own Risk".</li>
              <li>Special events planned by the board may temporarily change existing schedules, but such activities will be posted on the website at <a href="https://www.lockridgeforestswimtennis.com" className="text-primary-600 hover:underline">www.lockridgeforestswimtennis.com</a>.</li>
            </ol>
          </section>

          {/* Pool Guests */}
          <section id="pool-guests" className="mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-2 border-primary-600 pb-3">
              Pool Guest(s)
            </h2>
            <ol className="space-y-4 list-decimal list-inside text-gray-700">
              <li>Non-member residents of Lockridge Forest may NOT be a guest of a member or use any club facility except as approved by the current Board of Directors. Members who knowingly violate this provision may face suspension of their member privileges as determined by the Board of Directors.</li>
              <li>Pool guests must be accompanied by a Member. The member must pay the appropriate guest fees as determined by the current board of directors. There is one (1) exception:</li>
              <li>The "guest" is a caregiver and has been employed or requested by a member to supervise their child/dependent, and the board of directors has granted permission to the member and caregiver.</li>
              <li>When bringing (10) or more guests to the pool, prior approval must be obtained from the current board of directors to ensure adequate accommodations are available and necessary lifeguards are on duty.</li>
              <li>No guest shall attend more than once per week. A guest is defined as all non-dues paying persons. Members having guests is included as part of the membership fee, but frequently inviting the same guest is a violation of this policy and the Member may be required to pay a guest fee as determined by the current Board of Directors.</li>
            </ol>
          </section>

          {/* Get Togethers and Parties */}
          <section id="parties" className="mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-2 border-primary-600 pb-3">
              Get Togethers and Parties
            </h2>
            <p className="text-gray-700 mb-6">
              If you are inviting 10 or more guests to a gathering or birthday party at the pool, it is recommended that you reserve either the Taj or tennis pavilion for your group to ensure adequate tables and chairs remain available for our membership using the pool.
            </p>
            <ol className="space-y-4 list-decimal list-inside text-gray-700">
              <li>Facility reservations are first come first served. Availability can be checked on the <a href="/facility-reservation" className="text-primary-600 hover:underline">Facility Reservation Guidelines &amp; Calendar</a> on our club website.</li>
              <li>There may be a reservation fee and/or deposit required. The current Board of Directors will establish this fee/deposit. If a required deposit is not received there is no guarantee that the area will be available for your party.</li>
              <li>Reservations for the Tennis Pavilion and Taj building for birthdays and other functions must be requested online. See our website for information regarding use guidelines and to request a reservation.</li>
              <li>Taj access key is available within the main gated area to the Taj. If keys were used, they will need to be returned as well. If the club keys are lost there will be a $25 lost key charge.</li>
              <li>If the conditions outlined in the Facility Reservation Guidelines on our club website are not followed, and the Facilities conditions are not acceptable, future reservation privileges may be suspended/revoked.</li>
              <li>For birthday parties and other events, the board must be informed of the approximate number of guests who will be attending; how many are members, how many are non-members, how many adults; how many children; and how many will be swimming.
                <ul className="ml-8 mt-2 space-y-2 list-disc list-inside">
                  <li>At least one Member of the group must be a pool member in good standing and must be present at the function.</li>
                  <li>Residents of Lockridge Forest who are not members of the pool are not permitted to attend without expressed permission by the Board.</li>
                  <li>All Club By-laws and Pool Rules and Regulations of the pool are to be enforced.</li>
                </ul>
              </li>
              <li>The host member must inform non-member guests of the Club's Use Liability Waiver.</li>
              <li>Guests of the party are permitted to swim as guests of the host member in attendance of the party/gathering under the following conditions:
                <ul className="ml-8 mt-2 space-y-2 list-disc list-inside">
                  <li>Depending on the number of guests who will be using the pool, there may be a requirement for additional lifeguard(s) to be on duty.</li>
                  <li>Lifeguard(s) must be acquired through the Pool Management Company and paid for by the member (dependent on swim load). See Pool Birthday Parties on the <a href="https://poolmanagementinc.com/pool-party-reservations/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline">Pool Management Inc website</a>.</li>
                  <li>Please complete the pool party request ASAP with Pool Management Inc Pool Management. If an extra guard(s) is required and is not or cannot be provided, non-member guests will not be permitted to swim without express permission from the board of directors.</li>
                  <li>It is the responsibility of the person hosting the party to arrange and pay the fee directly with Pool Management Inc Pool Management to have an additional lifeguard.</li>
                </ul>
              </li>
              <li>Contact us via email request to admin@lockridgeforestswimtennis.com on our webpage if you have additional questions and we will assist you.</li>
            </ol>
          </section>

          {/* Tennis Pavilion / Taj Reservation Guidelines */}
          <section id="facility-guidelines" className="mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-2 border-primary-600 pb-3">
              Tennis Pavilion / Taj Reservation Guidelines
            </h2>
            <p className="text-sm text-gray-600 mb-6 italic">(Revised February 2025)</p>
            <div className="bg-secondary-50 border-l-4 border-secondary-600 p-4 rounded mb-6">
              <p className="text-gray-800 font-semibold">
                The Board has waived a deposit for club members for reserving the Tennis Pavilion or Taj Mahal. Please read the facility use guidelines below.
              </p>
            </div>

            {/* Tennis Pavilion Guidelines */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Tennis Pavilion</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>There are several charcoal grills on site available for use.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>All grilling tools, charcoal, etc. must be self-provided.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>Charcoal grill(s) are to be kept away from the pavilion structure when in use. Please move them out into the grass area a safe distance from the structure.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>Charcoal grills are to be fully extinguished using the hose provided, and the cold ashes removed from the grill upon completion of use and discarded in the dumpster at the far end of the parking lot. <strong>DO NOT LEAVE ASHES IN THE GRILL</strong></span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>Return the cleaned and cooled grill under the roof line of the pavilion, ready for use by the next member.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>Please check the deck and surrounding area and pick up any litter that may have accidentally been dropped.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>All trash is to be bagged and discarded into the dumpster at the far end of the parking lot.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>Replacement bags are available in the metal locker mounted on the telephone pole to the left of the pavilion as you face the courts.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>When departing, please make sure pavilion lights and ceiling fans are turned off.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>Report damaged items immediately to the CLUB.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 mr-3 mt-1 font-bold">•</span>
                  <span className="font-semibold">If the CLUB determines the area has not been cleaned and excessive efforts by the CLUB are required, member reservation privileges may be denied in the future.</span>
                </li>
              </ul>
            </div>

            {/* Taj Mahal Guidelines */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Taj Mahal</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>Keys are located in the Lockbox attached to the chain on upper gate driveway to Taj. These keys include keys to the gate and the Taj. Please do not forget to return keys to lockbox after your event. There will be a $25 fee to replace lost set of keys.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-3 mt-1">•</span>
                  <span>You may drive in to drop off supplies but please, <strong>NO PARKING</strong> vehicles at the Taj building.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Light / fan switches for interior and exterior are on the wall behind the refrigerator nearest door as you enter the Taj.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>All appliances are available for use.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>The circuit breaker for the stove/oven is left in the off position to prevent them from being left on accidentally. The breaker box in on the wall behind the freezer. You must make sure the stove/oven is turned off immediately after use and the circuit breaker is also turned off.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>The refrigerator(s) and freezer may contain items that belong to the club and are used for club sponsored functions and are not for general use. Please do not leave unused food items in the fridge or freezers.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>There are charcoal grills and propane grills on site available for use. Some grilling tools are available in the Taj. Charcoal and propane must be self-provided.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Charcoal grill(s) are to be kept away from the Taj structure when in use.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Charcoal grills are to be fully extinguished using the hose provided, and the cold ashes removed from the grill upon completion of use and discarded in the dumpster at the far end of the parking lot. <strong>DO NOT LEAVE ASHES IN THE GRILL</strong></span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>All grills used are to be left clean and ready for use by the next member.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Propane grills may be used under the covered structure with extreme caution.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Clean-up: brooms, paper towels, cleaning supplies and trash can liners are available for your use to aid in cleanup.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Always make sure all refrigerator doors are closed tightly and the stand-alone freezer top is lowered.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Empty all trash cans and discard trash in the dumpster located at the far end of the parking lot.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Straighten up furniture and sweep off / hose off the deck as needed.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Double check that the circuit breakers for the ovens are in the off position.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Turn off all light / fan switches.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Ensure Taj door is properly locked (give it a pull to make sure it doesn't open).</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Close and lock the entry drive-in gate to Taj returning keys to the lock box.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Report damaged items immediately to the CLUB.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 mr-3 mt-1 font-bold">•</span>
                  <span className="font-semibold">If the CLUB determines the area has not been cleaned and excessive efforts by the CLUB are required, member reservation privileges may be denied in the future.</span>
                </li>
              </ul>
            </div>

            {/* Swimming / Lifeguard Staffing */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Swimming</h3>
              <ul className="space-y-3 text-gray-700 mb-6">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Guests of the party are permitted to swim as guests of the member host of the party/gathering. All LFST pool rules apply.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>Depending on the number of guests who will be using the pool, there may be a requirement, per our contract with Pool Management Inc Pool Management, for additional lifeguard(s) to be on duty.</span>
                </li>
              </ul>

              <div className="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded mb-6">
                <p className="text-gray-800 font-semibold mb-2">
                  LFST assumes no liability of charges incurred due to the following Pool Management Inc Lifeguard Staffing Policy. All charges are the responsibility of the reserving member host. Use your own discretion.
                </p>
              </div>

              <div className="bg-gray-50 border border-gray-300 rounded-lg p-6 mb-6">
                <h4 className="text-lg font-bold text-gray-900 mb-3">Lifeguard Staffing Policies - Non-Standard Lifeguard Staffing</h4>
                <p className="text-gray-700 mb-4">
                  For all Non-Standard Lifeguard Hours for which the Customer requests the Company to provide lifeguards, the Customer shall provide full payment to the Company seven (7) days prior to the date such lifeguard service is required along with written notices as to:
                </p>
                <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-4 mb-6">
                  <li>The time and date of the party.</li>
                  <li>The number of people scheduled to attend; which includes both swimmers and non-swimmers.</li>
                  <li>Any special admission instructions.</li>
                  <li>The general age group of the people scheduled to attend.</li>
                </ol>
                <p className="text-red-700 font-semibold mb-6">
                  Pool Parties submitted less than 7 business days in advance will be charged a "Rush" fee of $50.00 to offset the cost related to last-minute scheduling if we are able to staff the event.
                </p>

                <p className="text-gray-700 mb-4">
                  A guest at a party is defined as any participant attending, regardless of the intent to swim. The Company [Pool Management Inc] and the Customer [Member/Host of Party] shall use the following scale to determine the number of lifeguards required for a Non-Standard Lifeguard Hours event:
                </p>

                <div className="overflow-x-auto mb-6">
                  <table className="min-w-full border-collapse border border-gray-300">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Number of People Scheduled to Attend</th>
                        <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Number of Lifeguards Required</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Up to 11</td>
                        <td className="border border-gray-300 px-4 py-2">0</td>
                      </tr>
                      <tr className="bg-gray-50">
                        <td className="border border-gray-300 px-4 py-2">12 – 25</td>
                        <td className="border border-gray-300 px-4 py-2">1</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">26 - 50</td>
                        <td className="border border-gray-300 px-4 py-2">2</td>
                      </tr>
                      <tr className="bg-gray-50">
                        <td className="border border-gray-300 px-4 py-2">51 - 75</td>
                        <td className="border border-gray-300 px-4 py-2">3</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">More than 75</td>
                        <td className="border border-gray-300 px-4 py-2">Company Discretion</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p className="text-red-700 font-semibold">
                  Any unscheduled parties with 15 or more guests will be subject to a charge of $100.00. If emergency staffing is available, the rate will be $50.00/hour. If emergency staffing is not available, then the Company reserves the right to close/cancel the party if the party poses a safety risk.
                </p>
              </div>

              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>To request additional lifeguards, please visit <a href="https://poolmanagementinc.com/pool-party-reservations/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Pool Parties - Pool Management Inc Pools</a> and fill out the form(s) located there.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>LFST assumes no responsibility for notifying Pool Management Inc of anticipated party guests.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3 mt-1">•</span>
                  <span>This is solely an agreement between reserving Member and Pool Management Inc. LFST is not responsible for negotiating or resolving any disputes that may arise.</span>
                </li>
              </ul>
            </div>

            <div className="bg-primary-50 border-l-4 border-primary-600 p-4 rounded">
              <p className="text-gray-800">
                Please contact us if you have additional questions and/or want to meet at the club to go over specific requests/concerns.
              </p>
              <p className="text-gray-800 mt-2">
                Regards,<br />
                <strong>LFST Board of Directors</strong>
              </p>
            </div>
          </section>

          <div className="bg-primary-50 border border-primary-200 rounded-lg p-6 text-center">
            <p className="text-gray-700 mb-4">
              For questions about any rules or policies, please contact the Board of Directors.
            </p>
            <a
              href="mailto:admin@lockridgeforestswimtennis.com"
              className="inline-block px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-medium transition-colors"
            >
              Contact Board of Directors
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Rules
